import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { TypeCompModel } from 'src/app/shared/models/simple-types/type-comp.model';
import { CompModel } from './../../../models/societe-linked/comp.model';
import { CompService } from './../../../services/societe-linked/comp.service';
import { TypeCompService } from '../../../services/simple/type-comp.service';
import { Form, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GestionCa1Component } from './../../../../core/gestion-referentiel/gestion-ca1/gestion-ca1.component';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';

export interface DialogData {
  form: UntypedFormGroup;
  comps: CompModel[];
  typeComp: TypeCompModel;
  societeId: number;
  result: boolean;
}
@Component({
  selector: 'app-modal-add-comp',
  templateUrl: './modal-add-comp.component.html',
  styleUrls: ['./modal-add-comp.component.scss']
})
export class ModalAddCompComponent implements OnInit {

  comps: CompModel[];
  form: UntypedFormGroup;
  typeComps: TypeCompModel[];
  type: TypeCompModel = null;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionCa1Component>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private router: Router
            , private typeCompService: TypeCompService
            , private compService: CompService) {

             }

  ngOnInit(): void {
    this.comps = this.data.comps;
    // Ajouter un SeuilModel + gestion des seuils
    this.form = this.data.form;
    // Récuperation des types
    this.typeCompService.getAll().subscribe(types => {
      this.typeComps = types;
    });
    if (this.form.get('id').value){
      this.type = this.data.typeComp;
    }
  }

  onChange(comp: TypeCompModel): void{
    this.form.get('idTypeComp').setValue(comp.id);
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const comp = this.form.getRawValue();
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.compService.save(comp).subscribe((a: CompModel) => {
            this.toastr.success('', 'Création du complément ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            this.toastr.error('', 'Erreur lors de l\'enregistrement du complément');
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.compService.update(comp.id, comp).subscribe((a: CompModel) => {
          this.toastr.success('', 'Modification du complément ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          this.toastr.error('', 'Erreur lors de l\'enregistrement du complément');
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}


